import React from 'react';
import styled from 'styled-components';

const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
`;

const DialogContainer = styled.div`
  background-color: #2a2d3a;
  border-radius: 8px;
  padding: 24px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  border: 1px solid #444;
`;

const DialogTitle = styled.h3`
  color: #fff;
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 600;
`;

const DialogMessage = styled.p`
  color: #ccc;
  margin: 0 0 24px 0;
  line-height: 1.5;
  font-size: 14px;
`;

const DialogButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  flex-wrap: wrap;
`;

const DialogButton = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  min-width: 80px;
  
  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const SaveButton = styled(DialogButton)`
  background-color: #1de9b6;
  color: #000;
  
  &:hover {
    background-color: #26efc2;
  }
`;

const DiscardButton = styled(DialogButton)`
  background-color: #f44336;
  color: #fff;
  
  &:hover {
    background-color: #f66356;
  }
`;

const CancelButton = styled(DialogButton)`
  background-color: #666;
  color: #fff;
  
  &:hover {
    background-color: #777;
  }
`;

const ConfirmationDialog = ({ 
  isOpen, 
  title, 
  message, 
  onSave, 
  onDiscard, 
  onCancel,
  saveButtonText = "Save",
  discardButtonText = "Don't Save",
  cancelButtonText = "Cancel"
}) => {
  if (!isOpen) return null;

  return (
    <DialogOverlay onClick={onCancel}>
      <DialogContainer onClick={(e) => e.stopPropagation()}>
        <DialogTitle>{title}</DialogTitle>
        <DialogMessage>{message}</DialogMessage>
        <DialogButtons>
          <CancelButton onClick={onCancel}>
            {cancelButtonText}
          </CancelButton>
          <DiscardButton onClick={onDiscard}>
            {discardButtonText}
          </DiscardButton>
          <SaveButton onClick={onSave}>
            {saveButtonText}
          </SaveButton>
        </DialogButtons>
      </DialogContainer>
    </DialogOverlay>
  );
};

export default ConfirmationDialog; 